import { GlassCard } from "@kj/design-system";

export default function MessagesModerationPage() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">Messages Moderation</h1>
      <p className="text-sm text-fg-muted">
        AI가 로맨스 사기·혐오·PII 누출 가능성 있는 메시지를 플래그합니다.
        원문 보존 없이 해시+요약만 노출됩니다.
      </p>
      <GlassCard padding="lg" radius="2xl">
        <div className="text-sm text-fg-muted text-center py-10">
          플래그된 메시지 없음.
        </div>
      </GlassCard>
    </div>
  );
}
